let content_blocks = require('../contents');

export function init(){
    
    $('#edit_title_modal .btn.delete').on('click', function(){
        let modal = $(this).closest('.modal');
        let block_id = modal.find('[name="block_id"]').val();
        $('#'+block_id).remove();
        content_blocks.show_start_block();
        content_blocks.show_block_order();

        modal.modal('hide');

        modal.find('form')[0].reset();
    });

    $('#edit_title_modal').on('show.bs.modal', function (event) {

        let button = $(event.relatedTarget);
        let block = $(button).closest('.block');
        let modal = $(this);

        let title = block.attr('data-title');
        let subtitle = block.attr('data-subtitle');
        let translations = [];

        try {

            translations = JSON.parse(block.attr('data-translations'));
            if(typeof translations[window._content_selected_language] != 'undefined'){
                
                if(typeof translations[window._content_selected_language]['title'] != 'undefined'){
                    title = translations[window._content_selected_language]['title'];
                }

                if(typeof translations[window._content_selected_language]['subtitle'] != 'undefined'){
                    subtitle = translations[window._content_selected_language]['subtitle'];
                }

            }

        } catch(err){}

        modal.find('[name="block_id"]').val(block.attr('id'));
        modal.find('[name="title"]').val(title);
        modal.find('[name="classes"]').val(block.attr('data-class'));
        modal.find('[name="width"]').val(block.attr('data-width')).trigger('change');
        modal.find('[name="subtitle"]').val(subtitle);

        let select_align = modal.find('[name="align"]');
        select_align.find('option[value="'+ block.attr('data-align') +'"]').prop('selected', true);
        select_align.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });

        let select_visible = modal.find('[name="visible"]');
        if (block.attr('data-visible') != null || block.attr('data-visible') != 'undefined') {
            select_visible.find('option[value="'+ block.attr('data-visible')).prop('selected', true);
        } else {
            select_visible.find('option[value="visible"]').prop('selected', true);
        }
        
        select_visible.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });

    });

    $('#edit_title').on('submit', function (e) {

        e.preventDefault();

        let block = $('#'+ $(this).find('[name="block_id"]').val());
        let title = $(this).find('[name="title"]').val();
        let width = $(this).find('[name="width"]').val();
        let subtitle = $(this).find('[name="subtitle"]').val();
        let align = $(this).find('[name="align"]').val();
        
        let translations = [];
        if(window._content_languages.length > 1){

            try {
                translations = JSON.parse(block.attr('data-translations'));
                if (translations.length == 0) {
                    translations = {}
                }
            } catch(err){
                translations = [];
            }

            // preparo traducciones que no existan

            for(let _language of window._content_languages){
                if(typeof translations[_language] == 'undefined'){
                    translations[_language] = { 'title': '', 'subtitle': '' };
                }
            }

            // guardo tranduccion actual 

            translations[window._content_selected_language]['title'] = title;
            translations[window._content_selected_language]['subtitle'] = subtitle;

            // si es idioma base

            if(window._content_selected_language == window._locale){

                block.attr('data-title', title);
                block.attr('data-subtitle', subtitle);

                // actualizamos traducciones vacias

                for(let _language of window._content_languages){
                    if(_language != window._locale){
                        if(translations[_language]['title'] == ''){
                            translations[_language]['title'] = title;
                        }
                        if(translations[_language]['subtitle'] == ''){
                            translations[_language]['subtitle'] = subtitle;
                        }
                    }
                }
            }

        } else {

            block.attr('data-title', title);
            block.attr('data-subtitle', subtitle);

        }

        block.attr('data-class', $(this).find('[name="classes"]').val());
        block.attr('data-visible', $(this).find('[name="visible"]').val());
        block.attr('data-width', width);
        block.attr('data-align', align);
        block.attr('data-translations', JSON.stringify(translations));

        update_preview(block, width, title, subtitle, align);
        
        content_blocks.change_visible_button_blocks(block);

        let modal = $(this).closest('.modal');
        modal.modal('hide');

    });

    $('.block[data-type="title"]').each(function() {
        content_blocks.create_visible_button_blocks($(this));
    })
}

export function init_edit_button(block_id) {

    let block = $('#content_blocks #' + block_id);
    block.find('.btn.edit').click(function(){
        
        let block = $(this).closest('.block');
        let form = $('#edit_title');
        form.find('[name="title"]').val(block.attr('data-title'));
        form.find('[name="block_id"]').val(block.attr('id'));

    });
}

function update_preview(block, width, title, subtitle, align){

    block.find('.card-header .info').html('<i class="fa-solid fa-heading"></i> <i class="fa-solid width fa-' + width.replace('h', '') + '"></i>');
    let col = block.find('.card-body:first .row .col');
    col.removeClass();
    col.addClass(['col', 'd-flex','justify-content-'+align]);
    if (width == 'h1') {
        col.html('<div><h3 class="trans title">' + title + '</h3><b class="trans subtitle">'+ subtitle +'</b></div>');
    } else {
        col.html('<div><h4 class="trans title">' + title + '</h4><b class="trans subtitle">'+ subtitle +'</b></div>');
    }
}